import { useState, useEffect, createRef } from "react";
import { disableMapEvents } from "./utils/mapFunctions";
import ZoomControl from "./widgets/ZoomControl";
import HomeControl from "./widgets/HomeControl";
import BasemapControl from "./widgets/BasemapControl";
import MeasureControl from "./widgets/MeasureControl";
import PrintControl from "./widgets/PrintControl";
import ShareControl from "./widgets/ShareControl";
import HelpControl from "./widgets/HelpControl";
import AboutControl from "./widgets/AboutControl";
import AoiControl from "./widgets/AoiControl";

const RightPanel = (props) => {
  const map = props.map;
  const panelRef = createRef();
  const [activeWidget, setActiveWidget] = useState(null);
  const [attribution, setAttribution] = useState();

  useEffect(() => {
    disableMapEvents(panelRef);
  }, [panelRef]);

  useEffect(() => {
    if (props.isMobile) {
      props.setActivePanel(activeWidget ? "right" : null);
    }
  }, [activeWidget, props]);

  const toggleActive = (newItem) => {
    setActiveWidget((prevItem) => (prevItem === newItem ? "" : newItem));
  };

  return (
    <div className="right-container">
      <div className="widget-panel widget-panel-right" ref={panelRef} style={{display: activeWidget ? "block" : "none"}}>
        <div className="widget-title">
          {activeWidget}
          <button className="icon-button widget-close" onClick={() => setActiveWidget()} aria-label="Close">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <BasemapControl map={map} active={activeWidget === "Basemaps"} setAttribution={setAttribution}/>
        {activeWidget === "Measurement" && <MeasureControl map={map} isMobile={props.isMobile} activeWidget={activeWidget}/>}
        {activeWidget === "AOI" && <AoiControl map={map} isMobile={props.isMobile} activeWidget={activeWidget}/>}
        {activeWidget === "Share" && <ShareControl/>}
        {activeWidget === "Help" && <HelpControl/>}
        {activeWidget === "About" && <AboutControl attribution={attribution}/>}
      </div>
      <div className="buttons-container buttons-container-right" style={{display: props.isMobile && activeWidget ? "none" : ""}}>
        <ZoomControl map={map}/>
        <HomeControl map={map} center={props.center} zoom={props.zoom}/>
        <button className={"ccl-button ccl-button--default ccl-button--default-neg map-button" + (activeWidget === "Basemaps" ? " active" : "")} aria-label="Basemaps" onClick={() => toggleActive("Basemaps")}>
          <div className="basemap-icon">
            <i className="fa-solid fa-square"></i>
            <i className="fa-solid fa-square"></i>
            <i className="fa-solid fa-square"></i>
            <i className="fa-solid fa-square"></i>
          </div>
        </button>
        <button className={"ccl-button ccl-button--default ccl-button--default-neg map-button" + (activeWidget === "Measurement" ? " active" : "")} onClick={() => toggleActive("Measurement")} aria-label="Measurement">
          <i className="fa-solid fa-ruler"></i>
        </button>
        <button className={"ccl-button ccl-button--default ccl-button--default-neg map-button" + (activeWidget === "AOI" ? " active" : "")} onClick={() => toggleActive("AOI")} aria-label="AOI">
          <i className="fa-solid fa-vector-square"></i>
        </button>
        <PrintControl setActiveWidget={setActiveWidget}/>
        <button className={"ccl-button ccl-button--default ccl-button--default-neg map-button" + (activeWidget === "Share" ? " active" : "")} onClick={() => toggleActive("Share")} aria-label="Share">
          <i className="fa-solid fa-share-nodes"></i>
        </button>
        <button className={"ccl-button ccl-button--default ccl-button--default-neg map-button" + (activeWidget === "Help" ? " active" : "")} onClick={() => toggleActive("Help")} aria-label="Help">
          <i className="fa-solid fa-circle-question"></i>
        </button>
        <button className={"ccl-button ccl-button--default ccl-button--default-neg map-button" + (activeWidget === "About" ? " active" : "")} onClick={() => toggleActive("About")} aria-label="About">
          <i className="fa-solid fa-message"></i>
        </button>
      </div>
    </div>
  );
};

export default RightPanel;
